export default "__VITE_ASSET__DfpR6_Pu__"